import React, { useEffect, useState } from 'react';
import './NewCampain.css';
import { getAllCandidates } from '../services/allcandidates';
import { registerCampaign } from '../services/registerCampaign';
import { registerCandidate } from '../services/registerCandidate';
import {  useLocation,useHistory } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import { usePromiseTracker } from "react-promise-tracker";
import { Oval } from 'react-loading-icons'
import { FaPowerOff } from 'react-icons/fa';
import { FaChartArea } from 'react-icons/fa';
import {useAuth } from '../AuthContext/AuthContext'
export default function NewCampain() {
    const { dispatch } = useAuth();
    const { promiseInProgress } = usePromiseTracker(); 
    const [candidates, setCandidates] = useState([]);
    const [checked, setChecked] = useState([]);
    const [Nombre, setNombre] = useState();
    const [Descripcion, setDescripcion] = useState();
    const [Votos, setVotos] = useState();
    const location = useLocation();
    let history = useHistory();  


    useEffect(() => {
        let mounted = true;
        
        getAllCandidates(dispatch.token)
        .then(response => {
                if(mounted){
                    setCandidates(response.body);
                }
                
        })
        return () => mounted = false;
    }, []) 

    const handleToggle = c => () => {
        const clickedCategory = checked.indexOf(c);
        const all = [...checked];
    
        if (clickedCategory === -1) {
          all.push(c);
        } else {
          all.splice(clickedCategory, 1);
        }
        setChecked(all);

      };

    let registrar = () => {
      registerCampaign(Nombre, Descripcion, Votos, dispatch.token)
      .then(response => {
        Promise.all([
          checked.forEach(element => {
                registerCandidate(response.body[0].IDCampana,element);
          })]).then(([items, contactlist, itemgroup])=>{
            mensaje("Se configuró la votación solicitada.");
            setNombre("");
            setDescripcion("");
            setVotos("");
          })
          
      })
        
    } 
    
    const mensaje = (respuesta) =>{
      confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className='custom-ui'>
                <center>
                <h1>{respuesta}</h1>  
                <button
                    className="button-modal-single"
                    onClick={() => {
                      onClose();
                    }}
                  >
                    Aceptar
                  </button>   
                  </center>         
              </div>
            );
          }
        });
  }


    function generateClient(candidate){
        return <div className={ "box"} key={candidate.IDCandidato}>
                 <div className='box-container' name="candidato" id={candidate.IDCandidato}> 
                    <input type="checkbox" onChange={handleToggle(candidate.IDCandidato)} value={candidate.IDCandidato}/>
                    <div className="name">{ candidate.Campana }</div> 
                    <div className="image">
                      <img src={candidate.Foto } className="candidato" alt={ candidate.Nombre }></img>
                    </div>
                    <div className="name">{ candidate.Candidato }</div>
                    </div>
              </div>  
                
      }

      function Loggout(){
        localStorage.clear();
        history.push("/login");
      }  

      function Admin(){
        history.push("/admin");
      }  
    
    return(<div className="login-wrapper">
            <div className='wrap header'>
                    <div className='logoContainer'>
                    <img src="https://guadalupanabucket.s3.us-east-2.amazonaws.com/f_logo.svg" className="logo" alt="Guadalupana"></img>
                    
                    </div>
                    { (location.pathname!=='/login' && location.pathname!=='/registro' )?
                    <div>
                        <button className={"button-small administracion"} onClick={Admin}><FaChartArea/>  Administración </button>
                        <button className={"button-small logout"} onClick={Loggout}><FaPowerOff/>  Salir </button>
                    </div>:
                    <div></div>
                    }
                </div>
            <div>
            <div className="login-wrapper card-register">
                <div className="text-card-register"> 
                
                    <div>Ingrese el nombre de la votación</div>
                    <input className="input-registro" placeholder="Nombre" value={Nombre} type="text" onChange={e => setNombre(e.target.value)}/>
                    <div>Ingrese la descripción</div>
                    <textarea className="input-registro input-registro-textarea" value={Descripcion} onChange={e => setDescripcion(e.target.value)}  />
                    <div>Cantidad de votos disponibles</div>
                    <input className="input-registro" placeholder="votos"  type="number" value={Votos} onChange={e => setVotos(e.target.value)} />
                </div>

                <center>
                    <button className="button-candidate button-register" onClick={registrar} disabled={ promiseInProgress || checked.length===0 ? "disabled" : "" } > 
                        { promiseInProgress ? "Registrar..." : "Registrar"} 
                        { promiseInProgress && <Oval className="loading-icon" /> }
                    </button>
                </center>    
                </div>  
            </div> 
            <div className="container-list">       
                    {
                        candidates.map(can => 
                            generateClient(can)
                        )
                    }
           </div>
        </div>
    )
}
